export default __webpack_public_path__ + "static/media/shey_pic.851b74ad.jpg";